import { BoxDropFile, Creatable, Input } from '@iveco-ti/iveco-ds'
import { FileUp } from 'lucide-react'
import { useTranslation } from 'react-i18next'

export function FormNewsSummary() {
  const { t } = useTranslation('panel')

  return (
    <div className="space-y-6 pb-4">
      <h2 className="text-2xl text-sky-700 font-semibold">
        {t('news.drawer_create_news.summary.title')}
      </h2>

      <Input.Base
        name="title"
        label={t('news.drawer_create_news.fields.title.label')}
        placeholder={t('news.drawer_create_news.fields.title.placeholder')}
      />

      <Input.Base
        name="subtitle"
        label={t('news.drawer_create_news.fields.subtitle.label')}
        placeholder={t('news.drawer_create_news.fields.subtitle.placeholder')}
      />

      <Creatable.Sync
        name="tag"
        isMulti
        label={t('news.drawer_create_news.fields.tag.label')}
        placeholder={t('news.drawer_create_news.fields.tag.placeholder')}
        noOptionsMessage={() => ''}
      />

      <h3 className="text-2xl text-sky-700 font-semibold">
        {t('news.drawer_create_news.summary.subtitle')}
      </h3>

      <Input.AddOn
        name="postExternalUrl"
        leadingAddOn="https://"
        label={t('news.drawer_create_news.fields.postExternalUrl.label')}
        placeholder={t(
          'news.drawer_create_news.fields.postExternalUrl.placeholder',
        )}
      />

      <BoxDropFile.Root>
        <BoxDropFile.Label>
          {t('news.drawer_create_news.fields.postFile.label')}
        </BoxDropFile.Label>

        <BoxDropFile.Input
          name="postFile"
          title={t('news.drawer_create_news.fields.postFile.title')}
        >
          <BoxDropFile.Icon icon={<FileUp />} />
        </BoxDropFile.Input>
      </BoxDropFile.Root>
    </div>
  )
}
